import { IsNotEmpty, IsUUID, IsString, IsOptional } from 'class-validator';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

export class AcceptDto {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  eventId: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  nodeId: string;

  @IsOptional()
  @IsString()
  signature?: string;

  attributes?: FormAttributesRequest;
}
